import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import clientRoutes from "@/router/items/ClientRoutes";

const routes = [...clientRoutes] as RouteRecordRaw[];
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
